import { getEachWayTitle } from "../getEachWayTitle";
import { EventsBySportIdRequest } from "sb-bff-integration";
export const getEventTitle = (event, market, eachWayString) => {
    if (event.type === EventsBySportIdRequest.EventTypesEnum.Outright.toString()) {
        let placeTerm = parseInt(market.metadata.placeTermsId);
        let oddsTerms = parseInt(market.metadata.oddsTermsId);
        const eachWay = oddsTerms && placeTerm
            ? getEachWayTitle(eachWayString, placeTerm, oddsTerms)
            : "";
        return `${event.eventName} ${eachWay} ${event.eventDate} | ${event.eventTime}`;
    }
    return event.eventName;
};
//# sourceMappingURL=getEventTitle.js.map